export default __webpack_public_path__ + "static/media/Andel_sm.7fe7744d.jpg";